var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5681 7.71017C5.10746 7.53038 5.5307 7.10714 5.71049 6.56777L6.02219 5.63268C6.08191 5.45353 6.24957 5.33268 6.43842 5.33268C6.62727 5.33268 6.79493 5.45353 6.85465 5.63268L7.16634 6.56777C7.34613 7.10714 7.76937 7.53038 8.30874 7.71017L9.24383 8.02186C9.42298 8.08158 9.54383 8.24924 9.54383 8.43809C9.54383 8.62694 9.42298 8.7946 9.24383 8.85432L8.30874 9.16602C7.76937 9.3458 7.34613 9.76905 7.16634 10.3084L6.85465 11.2435C6.79493 11.4227 6.62727 11.5435 6.43842 11.5435C6.24957 11.5435 6.08191 11.4227 6.02219 11.2435L5.71049 10.3084C5.5307 9.76905 5.10746 9.34581 4.5681 9.16602L3.63301 8.85432C3.45385 8.7946 3.33301 8.62694 3.33301 8.43809C3.33301 8.24924 3.45385 8.08158 3.63301 8.02186L4.5681 7.71017Z",
    fill: "url(#paint0_linear_677_4826)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46178 4.19721C9.80916 4.08141 10.0817 3.80883 10.1975 3.46146L10.3983 2.85923C10.4367 2.74384 10.5447 2.66602 10.6663 2.66602C10.788 2.66602 10.8959 2.74384 10.9344 2.85923L11.1352 3.46146C11.2509 3.80883 11.5235 4.08141 11.8709 4.19721L12.4731 4.39795C12.5885 4.43641 12.6663 4.54439 12.6663 4.66602C12.6663 4.78764 12.5885 4.89562 12.4731 4.93408L11.8709 5.13483C11.5235 5.25062 11.2509 5.5232 11.1352 5.87057L10.9344 6.4728C10.8959 6.58819 10.788 6.66602 10.6663 6.66602C10.5447 6.66602 10.4367 6.58819 10.3983 6.4728L10.1975 5.87057C10.0817 5.5232 9.80916 5.25062 9.46179 5.13483L8.85955 4.93408C8.74417 4.89562 8.66634 4.78764 8.66634 4.66602C8.66634 4.54439 8.74417 4.43641 8.85955 4.39795L9.46178 4.19721Z",
    fill: "url(#paint1_linear_677_4826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99588 10.6087C10.2854 10.5122 10.5125 10.285 10.609 9.99555L10.7763 9.49369C10.8083 9.39754 10.8983 9.33268 10.9997 9.33268C11.101 9.33268 11.191 9.39754 11.2231 9.49369L11.3904 9.99555C11.4868 10.285 11.714 10.5122 12.0035 10.6087L12.5053 10.776C12.6015 10.808 12.6663 10.898 12.6663 10.9993C12.6663 11.1007 12.6015 11.1907 12.5053 11.2227L12.0035 11.39C11.714 11.4865 11.4868 11.7137 11.3904 12.0031L11.2231 12.505C11.191 12.6012 11.101 12.666 10.9997 12.666C10.8983 12.666 10.8083 12.6012 10.7763 12.505L10.609 12.0031C10.5125 11.7137 10.2854 11.4865 9.99588 11.39L9.49402 11.2227C9.39786 11.1907 9.33301 11.1007 9.33301 10.9993C9.33301 10.898 9.39786 10.808 9.49402 10.776L9.99588 10.6087Z",
    fill: "url(#paint2_linear_677_4826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_677_4826",
    x1: 12.9997,
    y1: 3.33268,
    x2: 3.66634,
    y2: 11.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_677_4826",
    x1: 12.9997,
    y1: 3.33268,
    x2: 3.66634,
    y2: 11.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_677_4826",
    x1: 12.9997,
    y1: 3.33268,
    x2: 3.66634,
    y2: 11.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003D89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiAi);
export default __webpack_public_path__ + "static/media/GeminiAI.d9e404884b00a587e1f39962243d5e3d.svg";
export { ForwardRef as ReactComponent };